import React from 'react';
import Feedback from '../component/feedback';

export default function FeedbackPage() {
  return <Feedback />;
}

export async function getServerSideProps(context) {
  const accessToken = context.req.headers['web-access-token'] || '';

  return {
    props: {
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
      accessToken,
      isDev: process.env.TEST_ENV === 'test',
    },
  };
}
